import React from "react";
import { ButtonToolbar, Dropdown, Glyphicon, MenuItem } from "react-bootstrap";
import Client from "../Client";

const UserMenu = () => (
  <ButtonToolbar>
    <Dropdown
      bsStyle="default"
      title={Client.getUserName()}
      pullRight
      id="dropdown-no-caret"
    >
      <Dropdown.Toggle>
        <Glyphicon glyph="user" /> {Client.getUserName()}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <MenuItem eventKey="1" href={process.env.REACT_APP_VEHICLES_URL} target="_blank">
          Manage Vehicles
        </MenuItem>
        <MenuItem eventKey="2" href={process.env.REACT_APP_LOCATIONS_URL} target="_blank">
          Manage Locations
        </MenuItem>
        <MenuItem divider />
        <MenuItem eventKey="3" href="/logout">
          Logout
        </MenuItem>
      </Dropdown.Menu>
    </Dropdown>
  </ButtonToolbar>
);

export default UserMenu;



// WEBPACK FOOTER //
// ./src/components/UserMenu.js